const countryCallingCodes = [
  // Zone 1: NANP
  '+1',
  '+1 340',
  '+1 670',
  '+1 671',
  '+1 684',
  '+1 787',
  '+1 939',
  '+1 242',
  '+1 246',
  '+1 264',
  '+1 268',
  '+1 284',
  '+1 345',
  '+1 441',
  '+1 473',
  '+1 649',
  '+1 658',
  '+1 876',
  '+1 664',
  '+1 721',
  '+1 758',
  '+1 767',
  '+1 784',
  '+1 809',
  '+1 829',
  '+1 849',
  '+1 868',
  '+1 869',

  // Zone 2: Africa
  '+20',
  '+210',
  '+211',
  '+212',
  '+213',
  '+214',
  '+215',
  '+217',
  '+219',
  '+216',
  '+218',
  '+220',
  '+221',
  '+222',
  '+223',
  '+224',
  '+225',
  '+226',
  '+227',
  '+228',
  '+229',
  '+230',
  '+231',
  '+232',
  '+233',
  '+234',
  '+235',
  '+236',
  '+237',
  '+238',
  '+239',
  '+240',
  '+241',
  '+242',
  '+243',
  '+244',
  '+245',
  '+246',
  '+247',
  '+248',
  '+249',
  '+250',
  '+251',
  '+252',
  '+253',
  '+254',
  '+255',
  '+255 24',
  '+256',
  '+257',
  '+258',
  '+259',
  '+260',
  '+261',
  '+262',
  '+262 269',
  '+262 639',
  '+263',
  '+264',
  '+265',
  '+266',
  '+267',
  '+268',
  '+269',

  // Zones 3 & 4: Europe
  '+30',
  '+31',
  '+32',
  '+33',
  '+34',
  '+350',
  '+351',
  '+351 291',
  '+351 292',
  '+351 295',
  '+351 296',
  '+352',
  '+353',
  '+354',
  '+355',
  '+356',
  '+357',
  '+358',
  '+358 18',
  '+359',
  '+36',
  '+370',
  '+371',
  '+372',
  '+373',
  '+374',
  '+375',
  '+376',
  '+377',
  '+378',
  '+379',
  '+380',
  '+381',
  '+382',
  '+383',
  '+385',
  '+386',
  '+387',
  '+389',
  '+39',
  '+39 0549',
  '+39 06698',
  '+40',
  '+41',
  '+41 91',
  '+420',
  '+421',
  '+423',
  '+43',
  '+44',
  '+44 1481',
  '+44 1534',
  '+44 1624',
  '+45',
  '+46',
  '+47',
  '+47 79',
  '+48',
  '+49',

  // Zone 5: Americas
  '+500',
  '+501',
  '+502',
  '+503',
  '+504',
  '+505',
  '+506',
  '+507',
  '+508',
  '+509',
  '+51',
  '+52',
  '+53',
  '+54',
  '+55',
  '+56',
  '+57',
  '+58',
  '+590',
  '+591',
  '+592',
  '+593',
  '+594',
  '+595',
  '+596',
  '+597',
  '+598',
  '+599 3',
  '+599 4',
  '+599 7',
  '+599 9',

  // Zone 6: Asia & Oceania
  '+60',
  '+61',
  '+61 8 9162',
  '+61 8 9164',
  '+62',
  '+63',
  '+64',
  '+65',
  '+66',
  '+670',
  '+671',
  '+672 1',
  '+672 3',
  '+673',
  '+674',
  '+675',
  '+676',
  '+677',
  '+678',
  '+679',
  '+680',
  '+681',
  '+682',
  '+683',
  '+685',
  '+686',
  '+687',
  '+688',
  '+689',
  '+690',
  '+691',
  '+692',

  // Zone 7: Russia & neighbors
  '+7',
  '+7 840',
  '+7 940',
  '+7 850',
  '+7 929',
  '+7 0',
  '+7 6',
  '+7 7',

  // Zone 8: Special & East Asia
  '+800',
  '+801',
  '+802',
  '+803',
  '+804',
  '+805',
  '+806',
  '+807',
  '+808',
  '+809',
  '+81',
  '+82',
  '+83x',
  '+851',
  '+854',
  '+855',
  '+856',
  '+86',
  '+870',
  '+871',
  '+872',
  '+873',
  '+874',
  '+875',
  '+876',
  '+877',
  '+878',
  '+879',
  '+880',
  '+881',
  '+882',
  '+883',
  '+884',
  '+885',
  '+886',
  '+887',
  '+888',
  '+889',
  '+89x',

  // Zone 9: South/Central Asia & Middle East
  '+90',
  '+90 392',
  '+91',
  '+92',
  '+92 581',
  '+92 582',
  '+93',
  '+94',
  '+95',
  '+960',
  '+961',
  '+962',
  '+963',
  '+964',
  '+965',
  '+966',
  '+967',
  '+968',
  '+969',
  '+970',
  '+971',
  '+972',
  '+973',
  '+974',
  '+975',
  '+976',
  '+977',
  '+978',
  '+979',
  '+98',
  '+990',
  '+991',
  '+992',
  '+993',
  '+994',
  '+995',
  '+996',
  '+997',
  '+998',
  '+999'
];

const countryCallingCodeOptions = countryCallingCodes.map((code) => ({
  key: code,
  render: code,
  value: code
}));

export { countryCallingCodes, countryCallingCodeOptions };
